export {
  default as water,
  ReactComponent as Water,
} from '@assets/icons/features-and-amenities/water.svg'    
